export default {
  hero: { eyebrow: "Competition Studio · Module Premium", title: "Construire des compétitions d'élite qui ressemblent à des événements de radiodiffusion.", subtitle: "Concevoir des expériences de golf, de raquette et de compétition hybride avec des surfaces de sponsor premium, des storytelling en temps réel et des workflows de contrôle prêt à lancer." },
  actions: { create: "Créer une compétition", creating: "Créer...", demo: "Mode de démonstration de lancement", addScreen: "Ajouter l'écran", createGroup: "Créer un groupe d'écran", newCampaign: "Nouvelle campagne de commanditaire", previewBroadcast: "Aperçu de la radio", startBroadcast: "Démarrage", pauseBroadcast: "Pause", pushAnnouncement: "Annonce push", finalsMode: "Entrez le mode Finals" },
  metrics: { activeCompetitions: "Concours actifs", screensSynced: "Écrans synchronisés", sponsorsLive: "Commanditaires en direct", viewersNow: "Live Viewers (Maintenant)", totalScreens: "Total des écrans", onlineScreens: "Écrans en ligne", activeGroups: "Groupes d'écran actifs", campaignsToday: "Campagnes Live Today", tickerEnabled: "Ticker activé", broadcastingNow: "Radiodiffusion maintenant", matchesLive: "Matchs Live", activeBroadcasts: "Diffusions actives", announcementsToday: "Annonce aujourd ' hui", spotlightEvents: "Événements marquants", viewers: "Téléspectateurs" },
  builder: { journey: "Voyage de constructeur", readiness: "{value} % de lancement", tip: "Conseil : La console de lancement met à jour en direct lors de la conception de cet événement.", hybridHelp: "Mode hybride déverrouillé : concevoir un flux de compétition avec des moments de marque unifiés.", golfPresetHelp: "Presets de golf courbés prêts pour le lancement.", racquetPresetHelp: "Présets de raquettes curées prêts pour le lancement.", stageGolf: "Etape 1: Golf Seeding", stageRacquet: "Étape 2: Brackets Racquet", stageFinals: "Étape 3: Finales unifiées" },
  formats: { matchPlayDescription: "Élan de tête à tête, trou par trou." },
  journey: { sport: "Sport", format: "Format", setup: "Configuration", rules: "Règles", sponsors: "Coauteurs", launch: "Lancement" },
  screens: { eyebrow: "Salle de contrôle radiotélévision", title: "Studio de gestion d'écran", subtitle: "Contrôlez tous les écrans de lieux, monétise sponsor inventory, et orchestrez l'histoire premium in-club.", lastSeen: "Dernière vue {value}", noHeartbeat: "Pas de battement de coeur détecté" },
  live: { title: "Live concours studio", subtitle: "Commandez des matchs en direct, des émissions de contrôle et des récits en temps réel." },
  announcements: { finalGroupCamera: "Final group enter signature par-3 live camera window.", courtTieBreak: "Cour 1 semi-finale entrant décisif coup d'égalité.", hospitalityOpen: "Terrasse d'accueil maintenant ouverte pour les spectateurs finals." },
  spotlight: { onFire: "En feu", closingHole: "Trou de fermeture", bounceBack: "Accélération de l ' avance" },
  timeline: { ethanBirdie15: "Ethan birdie sur 15", crowdSurge: "Surplomb de la foule au court central", lucasReplay: "Replay de Lucas", semiFinalTieBreak: "La demi-finale débute", spotlightHole16: "Interrupteur de projecteur au trou 16" },
  canonical: { sports: { golf: "Golf", racquet: "Raquette", multiSport: "Multi-Sport" }, statuses: { draft: "Brouillon", openForEntries: "Ouvert pour les entrées", entriesClosed: "Entrées fermées", inProgress: "En cours", completed: "Terminé", cancelled: "Annulé" }, participants: { individual: "Individu", team: "Équipe", hybrid: "Hybride" }, broadcastModes: { leaderboardFocus: "De haut niveau", matchFocus: "Focus sur le match", playerSpotlight: "Joueur spotlight", finalsMode: "Mode final" }, previewModes: { leaderboardFocus: "De haut niveau", sponsorTicker: "Bandeau des sponsors", matchCentre: "Centre de correspondance", welcomeScreen: "Écran de bienvenue", splitView: "Vue divisée", sponsorAdvertCard: "Parrainage de la carte", playerSpotlight: "Joueur spotlight" }, tickerThemes: { darkNeon: "Néon foncé", championshipGold: "Championnat d'or", clubClassic: "Club classique" }, tickerSpeeds: { slow: "Lent", standard: "Norme standard", fast: "Vite !" }, matchStatuses: { live: "En direct", upcoming: "À venir", completed: "Terminé" }, screenStatuses: { online: "En ligne", offline: "Hors ligne" }, contestTypes: { closestToPin: "Le plus près du Pin", longestDrive: "Moteur le plus long" }, fantasyFormats: { salaryCap: "Capsule de traitement", pickPlayers: "Choix des joueurs" } },
  validation: { nameRequired: "Le nom de la concurrence est requis.", sportRequired: "Veuillez choisir un sport.", typeRequired: "Veuillez choisir un type de compétition.", startRequired: "La date de début est requise.", missingTitle: "Manque des champs obligatoires", missingDescription: "Veuillez remplir les champs surlignés avant de créer votre concours." },
  errors: { create: "Incapable de créer une concurrence", review: "Veuillez réexaminer vos détails et réessayer." },
  toasts: { created: "Compétition créée", createdDescription: "Votre compétition a été enregistrée comme un projet et est prête pour les prochaines étapes." },
  screenToasts: { missingClub: "Le contexte du club manquant", missingClubDescription: "Incapable de résoudre le code club.", createError: "Impossible de créer l'écran", refreshError: "Incapable de rafraîchir le code", saveError: "Impossible d'enregistrer l'écran", updated: "Écran mis à jour", disconnectError: "Incapable de déconnecter", disconnected: "Dispositif déconnecté", reconnectError: "Impossible de générer du code de reconnect", retry: "Veuillez réessayer." },
  clipboard: { copied: "Copié", failed: "Bien reçu.", manual: "Veuillez copier le lien manuellement.", screenLinkCopied: "Lien de l'écran copié", linkFailed: "Incapable de copier le lien" },
  confirmations: { deleteContest: "Êtes-vous sûr de vouloir supprimer ce concours?", removePlayer: "Vous êtes sûr? Cela va retirer le joueur de la compétition.", overwritePairings: "Cela va écraser les paires existantes.", clearTeeTimes: "Ça va effacer tous les départs." },
  accessibility: { editContest: "Edit concours", deleteContest: "Supprimer le concours", editEntry: "Modifier l ' entrée de la concurrence", deleteEntry: "Supprimer l ' entrée en concurrence", copyClubCode: "Code club de copie", copyPairingUrl: "Copier l'URL de paire", copyScreenUrl: "Copier l'URL" },
  preview: { assignedCompetition: "Compétition attribuée", scheduledDay: "Horaire · Jour 1 de 3", liveUpdates: "Mises à jour en direct du classement et notation en cours", presentedByPartners: "Présenté par Club Partners", presentedBy: "Présenté par {sponsor}", dayProgress: "Jour {day} de {total}", tickerFallback: "Privana broadcast ticker · mises à jour en direct à suivre sous peu", frontOfHouse: "Devant la maison", awaitingAssignment: "Attente de l ' affectation à la concurrence", standby: "En attente", graphicsReadyNext: "Les graphiques diffusés sont prêts pour le prochain départ de la compétition.", broadcast: "Competition", liveCoverage: "Couverture de la concurrence en direct", graphicsReady: "Graphiques de diffusion prêt", clubhouse: "Club-house", welcome: "Bienvenue au Privana Club", competitionUpdates: "Mises à jour de la concurrence en direct", stayTuned: "Restez à l'écoute des changements de classement" },
  copy: {
    "competition_not_found": "Compétition non trouvée",
    "back_to_competitions": "Retour aux compétitions",
    "back_to_all_competitions": "Retour à toutes les compétitions",
    "sponsored_by": "Parrainé par :",
    "leaderboard": "Chef de file",
    "entries": "Entrées (en anglais)",
    "tee_sheet": "Feuille de départs",
    "contests": "Concours",
    "fantasy": "Fantasme",
    "signage": "Signalisation",
    "live_leaderboard": "Direct Leaderboard",
    "no_scores_submitted_yet": "Aucun avis n'a encore été présenté.",
    "pos": "Pos",
    "player": "Joueur",
    "h_cap": "H'cap",
    "total": "Total",
    "live": "EN DIRECT",
    "competition_feed": "Concours feed",
    "venue": "Lieu de réunion",
    "scoring_feed_connected_awaiting_first_results": "Fil de notation connecté · en attendant les premiers résultats",
    "fantasy_leaderboard": "Fantasme Leaderboard",
    "rank": "Classe",
    "member": "Membre",
    "team_name": "Nom d ' équipe",
    "points": "Points",
    "fantasy_golf_setup": "Fantastique jeu de golf",
    "configure_the_fantasy_game_for_this_competition": "Configurer le jeu de fantasme pour cette compétition.",
    "edit_configuration": "Modifier la configuration",
    "format": "Format:",
    "team_size": "Taille de l'équipe:",
    "captain": "Capitaine :",
    "no_fantasy_game_configured_yet": "Aucun jeu de fantaisie configuré pour l'instant.",
    "fantasy_game_configuration": "Configuration du jeu Fantasy",
    "team_size_2": "Taille de l'équipe",
    "picks_lock_time": "Temps de verrouillage des Picks",
    "enable_captain_2x_points": "Activer le capitaine (2x Points)",
    "prize_pool_description": "Prix de la piscine",
    "cancel": "Annuler",
    "save_configuration": "Enregistrer la configuration",
    "on_course_contests": "Concours en cours",
    "manage_special_contests_like_longest_drive": "Gérez des concours spéciaux comme Longest Drive.",
    "new_contest": "Nouveau concours",
    "hole": "- Hole",
    "winner": "Gagnant :",
    "no_winner_declared_yet": "Aucun gagnant n'a encore été déclaré.",
    "no_on_course_contests_created_yet": "Pas encore de concours sur cours.",
    "contest_type": "Type de concours",
    "closest_to_the_pin": "Le plus près du Pin",
    "longest_drive": "Moteur le plus long",
    "hole_number": "Nombre de trous",
    "winner_2": "Gagnant",
    "select_winner": "Sélectionnez le gagnant",
    "none": "Aucun",
    "result": "Résultat",
    "e_g_315_yards_or_3ft_2in": "par exemple, 315 yards ou 3ft 2in",
    "save_contest": "Concours",
    "template": "Modèle",
    "device_preview": "Aperçu de l ' appareil",
    "contest_winners": "Gagnants du concours",
    "on_course_contest_results": "Résultats du concours en cours",
    "sponsored_by_2": "Commandité par",
    "contest_winners_will_be_announced_soon": "Les gagnants du concours seront annoncés bientôt.",
    "last_updated": "Dernière mise à jour:",
    "welcome_to_the": "Bienvenue à la",
    "waiting_for_scores": "J'attends des scores...",
    "format_studio": "Atelier des formats",
    "demo_ready": "Démo Ready",
    "hybrid_competition_flow": "Volet de la concurrence hybride",
    "popular": "Populaire",
    "competition_blueprint": "Plan de la concurrence",
    "shape_identity_schedule_and_participation_with_a_broadcast_grade": "Formez l'identité, l'horaire et la participation avec une installation de qualité radiodiffusée.",
    "event_identity": "Identité d ' événement",
    "competition_name": "Nom de la concurrence",
    "privana_signature_invitational": "Privana invitation de signature",
    "short_description": "Description courte",
    "a_multi_discipline_premium_member_event_with_live_coverage": "Un événement membre de prime multidiscipline avec couverture en direct et intégration des commanditaires.",
    "venue_location": "Lieu / emplacement",
    "championship_course_center_court": "Cours de championnat + Cour du centre",
    "schedule_participation": "Horaire et participation",
    "start_date": "Date de début",
    "end_date": "Date de fin",
    "max_participants": "Nombre de participants",
    "mode": "Mode",
    "individual": "Individu",
    "team": "Équipe",
    "hybrid": "Hybride",
    "rules_scoring_modules": "Règles & Modules de notation",
    "compose_scoring_logic_blocks_that_feel_ready_for_real": "Composez des blocs logiques qui se sentent prêts pour des opérations réelles.",
    "core_scoring_controls": "Commandes de notation de base",
    "live_scoring_enabled": "Signification en direct activée",
    "gross_net_leaderboard": "Brut + tableau de bord net",
    "round_match_days": "Jours de la ronde / match",
    "golf_engine": "Moteur de golf",
    "handicap_allowances": "Indemnités pour handicapés",
    "tie_break_policy": "Politique d ' aiguillage",
    "back_nine": "Neuf",
    "last_6_holes": "Les 6 derniers Holes",
    "sudden_death_playoff": "Jeu de la mort soudaine",
    "racquet_engine": "Moteur Racquet",
    "set_format": "Format",
    "best_of_3": "Meilleur de 3",
    "best_of_5": "Meilleur de 5",
    "fast_4": "Rapide 4",
    "points_structure": "Structure des points",
    "standard": "Norme standard",
    "golden_point_deuce": "Point d'or deuce",
    "timed_match_format": "Format de match chronométré",
    "sponsorship_branding_studio": "Sponsoring & Branding Studio",
    "competition_page": "Page de la concurrence",
    "tv_ticker": "Bandeau défilant TV",
    "screen_adverts": "Annonces d'écran",
    "screen_overlays": "Couvertures d ' écran",
    "position_sponsor_inventory_across_pages_tickers_and_premium_screen": "Placer l'inventaire des parrains sur les pages, les tickers et les surfaces d'écran premium.",
    "title_sponsor": "Titre sponsor",
    "logo_media_slot": "Logo / Fente de médias",
    "1200x600_png_svg": "1200x600 · PNG/SVG",
    "supporting_sponsor_1": "Soutenir le promoteur 1",
    "supporting_sponsor_2": "Soutenir le sponsor 2",
    "commercial_surface_preview": "Vue de la surface commerciale",
    "competition_header": "En-tête de compétition",
    "ticker_rotation": "Rotation d ' un ticker",
    "sponsor_loop": "BOUCLE DES SPONSORS",
    "launch_console": "Console de lancement",
    "review_launch": "Vérifier et lancer",
    "your_premium_event_package_ready_for_broadcast_and_member": "Votre forfait événement premium, prêt à être diffusé et communiqué aux membres.",
    "competition": "Compétition",
    "saved_id": "Numéro enregistré:",
    "max": "max.",
    "launch_readiness": "Préparation au lancement",
    "all_required_launch_fields_are_complete": "Tous les champs de lancement requis sont complets.",
    "save_draft": "Échec",
    "preview_screens": "Écrans de prévisualisation",
    "launch_confidence": "Confiance de lancement:",
    "complete_identity_and_scheduling_fields_to_finalize_a_fully": "Compléter les champs d'identité et de planification pour finaliser un paquet de compétition entièrement prêt.",
    "screen_inventory": "Inventaire d ' essai",
    "select_a_screen_to_load_its_live_preview_and": "Sélectionnez un écran pour charger ses surfaces de prévisualisation et de commande en direct.",
    "no_screens_added_yet": "Pas d'écran ajouté pour le moment",
    "create_and_pair_your_first_competition_screen_to_unlock": "Créez et appariez votre premier écran de compétition pour débloquer l'inventaire en direct, la télémétrie d'état et le contrôle ciblé.",
    "one_time_pairing_flow_for_tvs_and_signage_laptops": "• Un flux de jumelage unique pour les téléviseurs et les ordinateurs portables",
    "persistent_screen_sessions_with_heartbeat_presence": "• Séances d’écran persistantes avec présence de battement de coeur",
    "layout_and_sponsor_orchestration_from_one_control_room": "• Mise à disposition et parrainage de l’orchestration d’une salle de commande",
    "add_screen": "Ajouter l'écran",
    "manage_screen": "Gérer l'écran",
    "layout": "Disposition :",
    "source": "Source :",
    "ticker": "Tais-toi.",
    "ad_loop": "Boucle publicitaire :",
    "live_preview_canvas": "Toile de prévisualisation en direct ·",
    "ticker_configuration": "Configuration de Ticker",
    "broadcast_footer_controls_for_sponsors_match_updates_and_urgent": "Contrôles des pieds radiodiffusés pour les sponsors, mises à jour des matchs et annonces urgentes.",
    "ticker_enabled": "Ticker activé",
    "theme": "Thème",
    "speed": "Vitesse",
    "logo_mode": "Mode Logo",
    "sponsor_logos_only": "Les logos commanditaires seulement",
    "logos_text": "Logos + texte",
    "include_competition_updates": "Inclure les mises à jour de la concurrence",
    "urgent_announcements": "Annonces urgentes",
    "ticker_sim_rolex_finals_countdown_court_1_live_in": "[Ticker Sim] Rolex Finals Countdown · Court 1 live à 04:00 · La vitrine partenaire d'accueil commence à 18:00.",
    "advert_scheduler_playlist": "Planificateur publicitaire et liste de diffusion",
    "design_sponsor_playback_loops_and_intermission_placements_with_commercial": "Conception des boucles de lecture et des placements d'intermission avec clarté commerciale.",
    "assigned": "Affecté :",
    "playlist_timeline": "Calendrier de la liste de lecture",
    "screen_groups": "Groupes d ' écran",
    "deploy_synchronized_layouts_and_sponsor_packages_to_grouped_venue": "Déployez des mises en page synchronisées et des paquets sponsorisés pour regrouper des zones de lieux.",
    "screens": "écrans ·",
    "active_campaigns": "campagnes actives",
    "assign_layout": "Assignez Layout",
    "push_campaign": "Campagne Push",
    "content_rotation_timeline": "Temps de rotation du contenu",
    "static_demo_loop_builder_showing_proportioned_broadcast_sequencing": "Le constructeur de boucles de démonstration statiques montrant des séquences de diffusion proportionnelles.",
    "s": "s",
    "loop_length": "Longueur de boucle :",
    "s_auto_repeats_continuously_on_assigned_screens": "s · Auto-repeats en continu sur les écrans assignés.",
    "sponsor_campaign_manager": "Parraine campagne manager",
    "sales_friendly_campaign_snapshots_for_sponsors_targets_frequencies_and": "Des images de campagne favorables aux ventes pour les commanditaires, les cibles, les fréquences et les priorités.",
    "type": "Type:",
    "competition_2": "Concours:",
    "dates": "Dates :",
    "targets": "Cibles :",
    "playback": "Lecture:",
    "priority": "Priorité:",
    "live_override_console": "Console de remplacement en direct",
    "instant_operational_controls_for_high_pressure_moments": "Contrôles opérationnels instantanés pour des moments de haute pression.",
    "add_competition_screen": "Ajouter l'écran de la concurrence",
    "create_a_screen_and_generate_a_short_lived_one": "Créer un écran et générer un code de jumelage unique à courte durée.",
    "pair_your_screen_first": "Paire ton écran d'abord",
    "follow_these_quick_steps_on_the_target_display_before": "Suivez ces étapes rapides sur l'écran cible avant de créer cet écran.",
    "step_1_open_this_on_your_screen": "Étape 1 · Ouvrez-le sur votre écran",
    "step_2_enter_your_club_code": "Étape 2 · Entrez votre code club",
    "screen_name_display_name": "Nom d'écran / Nom d'affichage",
    "this_helps_your_team_identify_the_display_location_quickly": "Cela aide votre équipe à identifier rapidement l'emplacement de l'affichage.",
    "active_one_time_code": "Code à temps unique actif",
    "code_refreshes_in": "Le code se rafraîchit",
    "current_code_expires_at": "Le code actuel expire à",
    "club_code": "Code du club",
    "base_pairing_url": "URL de jumelage de base",
    "unique_screen_url": "URL d ' écran unique",
    "open": "Ouvrir",
    "on_the_target_screen_enter_club_code": "sur l'écran cible, entrez le code club",
    "then_enter_the_one_time_code": ", puis entrez le code à une fois.",
    "done": "Terminé",
    "edit_broadcast_behavior_and_device_state": "Modifier le comportement de diffusion et l'état de l'appareil.",
    "display": "Afficher",
    "display_name": "Nom d ' écran",
    "location": "Lieu",
    "screen_link": "Lien d ' écran",
    "copy_the_direct_display_url_for_this_screen": "Copiez l'URL d'affichage direct pour cet écran.",
    "copy_screen_link": "Lien de l'écran",
    "broadcast": "Diffusion",
    "layout_preset": "Prédéfinie de la mise en page",
    "select_layout_preset": "Sélectionnez la configuration prédéfinie",
    "unknown_preset_saved": "Présence inconnue (enregistré):",
    "assigned_competition_id": "Compétition assignée",
    "device": "Dispositif",
    "orientation": "Orientation",
    "resolution": "Résolution",
    "group_id": "Groupe ID",
    "messaging": "Messagerie",
    "standby_message": "Message de mise en attente",
    "toggles": "Lunettes",
    "public_facing": "Public face",
    "reconnect_screen": "Réconnecter l'écran",
    "use_this_one_time_code_to_pair_the_existing": "Utilisez ce code unique pour recouper l'écran existant.",
    "one_time_code": "Code à temps unique",
    "loading_managed_screens": "Chargement des écrans gérés...",
    "create_and_pair_your_first_screen_to_unlock_live": "Créez et apposez votre premier écran pour déverrouiller en direct ticker, advert scheduling, et les commandes de mise en page.",
    "live_match_selector": "Sélecteur de correspondance en direct",
    "choose_the_active_match_feed_for_command_operations": "Choisissez le flux de correspondance actif pour les opérations de commande.",
    "status": "· Statut:",
    "broadcast_mode": "Mode de diffusion",
    "select_mode": "Sélectionnez le mode",
    "player_spotlight": "Joueur spotlight",
    "current_leader": "Leader actuel ·",
    "featured_live": "· En direct",
    "live_ticker": "Bandeau en direct :",
    "leaderboard_control_panel": "Panneau de commande leader",
    "match_control_panel": "Panneau de contrôle de la correspondance",
    "announcements_panel": "Groupe d ' annonces",
    "type_announcement": "Annonce de type...",
    "push_announcement": "Annonce push",
    "spotlight_queue_panel": "Spotlight file panel",
    "push_to_broadcast": "Poussée à diffuser",
    "remove": "Retirer",
    "match_timeline_panel": "Panneau de temps de correspondance",
    "live_sequence_of_score_updates_events_and_highlight_triggers": "La séquence en direct des mises à jour de partitions, des événements et des déclencheurs de mise en valeur.",
    "production_critical_actions_for_high_pressure_broadcast_control": "Actions critiques pour le contrôle de la radiodiffusion à haute pression.",
    "manage_pairings_and_tee_times": "Gérer les paires et les départs.",
    "auto_generate": "Générer automatiquement",
    "clear_sheet": "Fiche de dégagement",
    "tee_time": "Départ",
    "players": "Joueurs",
    "tee_sheet_has_not_been_generated": "La feuille de départs n'a pas été générée.",
    "search_members": "Rechercher des membres...",
    "no_members_found": "Aucun membre trouvé.",
    "selected": "Sélectionné:",
    "competition_entries": "Concours de participation",
    "manage_participants_for_this_event": "Gérer les participants à cet événement.",
    "add_participants": "Ajouter les participants",
    "player_name": "Nom du joueur",
    "h_cap_index": "Indice h'cap",
    "playing_h_cap": "Jouer H'cap",
    "payment": "Paiement",
    "actions": "Actions",
    "no_entries_yet": "Pas encore d'entrées.",
    "edit_entry": "Modifier la rubrique",
    "handicap_index": "Index handicap",
    "save_changes": "Sauvegarder les changements",
    "add_new_participants": "Ajouter de nouveaux participants",
    "members": "Membres",
    "h_cap_index_2": "Index de H'Cap",
    "next": "Suivant",
    "back": "Retour",
    "save_participants": "Économiser les participants",
    "starting_times": "Démarrage des heures",
    "tee_times_have_not_been_assigned_yet": "Les temps des dents n'ont pas encore été assignés.",
    "golf": "Golf",
    "precision_scoring_and_marquee_course_storytelling": "La marque de précision et l'histoire du cours de marquee.",
    "ideal_for_member_majors_invitationals_and_broadcast_ready_rounds": "Idéal pour les majors membres, les invitations et les séries diffusées.",
    "racquet": "Raquette",
    "tennis_padel_and_racquet_leagues_in_one_flow": "Tennis, padel et racquet ligues en un seul flux.",
    "built_for_ladders_tournaments_and_club_vs_club_showcases": "Construit pour les échelles, les tournois et les vitrines club-vs-club.",
    "multi_sport": "Multi-Sport",
    "a_premium_hybrid_event_engine_for_signature_championships": "Un moteur hybride premium pour les championnats de signature.",
    "combine_golf_racquet_stages_with_unified_club_wide_storytelling": "Combinez des stades de golf + raquettes avec des histoires unifiées à l'échelle du club.",
    "stableford": "Écurie",
    "points_by_hole_with_handicap_friendly_pacing": "Points par trou avec un pacte adapté aux handicaps.",
    "strategic_fast": "Stratégique · rapide",
    "stroke_play": "Jeu de course",
    "classic_aggregate_scoring_across_rounds": "Un agrégat classique à travers les rondes.",
    "traditional_premium": "Traditionnelle · Premium",
    "match_play": "Match Play",
    "dramatic_broadcast": "Dramatic · Diffusion",
    "best_ball_scramble": "La meilleure boule de neige",
    "team_creativity_with_best_shot_selection": "La créativité de l'équipe avec une sélection optimale.",
    "social_team_energy": "Social · Énergie d'équipe",
    "wolf": "Loup",
    "rotating_strategy_and_decision_pressure_each_hole": "Stratégie tournante et pression de décision chaque trou.",
    "dynamic_interactive": "Dynamique · interactif",
    "round_robin": "Rond Robin",
    "balanced_fixture_grid_with_standings_momentum": "Grille de fixation équilibrée avec une dynamique de maintien.",
    "fair_consistent": "Équitable · cohérent",
    "knockout": "Toc",
    "single_elimination_bracket_with_spotlight_matches": "Support mono-élimination avec allumettes de projecteur.",
    "fast_high_stakes": "Fast · Stakes élevées",
    "double_elimination": "Double élimination",
    "second_life_pathway_with_stronger_parity": "Deuxième voie de vie avec plus de parité.",
    "competitive_extended": "Compétitivité · Extended",
    "ladder_league": "Ligue de l'échelle",
    "challenge_ladder_for_season_long_movement": "Échelle de défi pour le mouvement toute la saison.",
    "persistent_engaging": "Persistant · engageant",
    "team_league": "Équipe League",
    "squad_fixtures_with_tactical_lineups": "Fixations d'escouade avec des lineups tactiques.",
    "club_pride_tactical": "L'orgueil du club · tactique",
    "sport": "Sport",
    "format_2": "Format",
    "setup": "Configuration",
    "rules": "Règles",
    "sponsors": "Coauteurs",
    "launch": "Lancement",
    "layout_1": "Mise en page 1",
    "main_feed_with_right_side_leaderboard_rail_and_live": "Alimentation principale avec rail de bord droit et moins de trois tiers ticker",
    "leaderboard_focus": "De haut niveau",
    "sponsor_ticker": "Bandeau des sponsors",
    "match_centre": "Centre de correspondance",
    "welcome_screen": "Écran de bienvenue",
    "split_view": "Vue divisée",
    "sponsor_advert_card": "Parrainage de la carte",
    "video_advert": "Vidéo Advert",
    "every_3_mins": "Tous les 3 min",
    "live_2": "En direct",
    "bar_lounge_lobby": "Bar et salon, hall",
    "image_advert": "Publicité illustrée",
    "every_loop": "Chaque boucle",
    "queued": "Filed",
    "golf_areas": "Domaines de golf",
    "full_screen_takeover": "Prise en charge complète",
    "top_of_hour": "Haut de l'heure",
    "all_public_screens": "Tous les écrans publics",
    "intermission_card": "Carte d’intermission",
    "between_matches": "Entre les matchs",
    "draft": "Brouillon",
    "racquet_areas": "Zones de raquette",
    "sponsor_slate": "Parrain Slate",
    "every_5_mins": "Toutes les 5 minutes",
    "reception_lobby": "Réception et hall",
    "bar_lounge": "Bar et salon",
    "leaderboard_focus_2": "De haut niveau",
    "reception_lobby_2": "Réception et hall",
    "welcome_screen_2": "Écran de bienvenue",
    "golf_areas_2": "Domaines de golf",
    "clubhouse_mixed_feed": "Clubhouse Mixte Feed",
    "racquet_areas_2": "Zones de raquette",
    "match_centre_2": "Centre de correspondance",
    "all_public_screens_2": "Tous les écrans publics",
    "finals_day_mode": "Mode Finals Day",
    "fixtures": "Fixations",
    "sponsor_reel": "Séquence des sponsors",
    "match_spotlight": "Match à l’honneur",
    "club_promo": "Promotion du club",
    "premium_brand_loop": "Boucle de marque premium",
    "all_public_screens_3": "Tous les écrans publics",
    "every_4_mins": "Tous les 4 min",
    "active": "Actif",
    "equipment_launch": "Lancement de matériel",
    "golf_areas_3": "Domaines de golf",
    "every_6_mins": "Tous les 6 min",
    "lifestyle_spotlight": "Style de vie Spotlight",
    "bar_lounge_2": "Bar et salon",
    "hourly_takeover": "Heure de prise de contrôle",
    "scheduled": "Planifié",
    "wellness_card": "Carte de bien-être",
    "racquet_areas_3": "Zones de raquette",
    "every_loop_2": "Chaque boucle",
    "leaderboard_focus_3": "De haut niveau",
    "live_leaderboard_dominance": "Dominance dominante en direct",
    "scores_stay_central_with_a_compact_sponsor_ribbon_and": "Les scores restent au centre avec un ruban de parrain compact et une repose-pieds lisible en rotation.",
    "sponsor_ticker_2": "Bandeau des sponsors",
    "sponsor_led_ticker_mode": "Mode d ' étiquetage dirigé par le promoteur",
    "commercial_headlines_lead_the_footer_while_updates_pulse_between": "Les titres commerciaux conduisent le pied de page tout en mettant à jour l'impulsion entre les placements.",
    "match_centre_3": "Centre de correspondance",
    "match_centre_telemetry": "Télémétrie du centre de correspondance",
    "fixture_cards_and_live_status_widgets_prioritize_active_court": "Cartes de fixation et widgets de statut direct priorisent les moments de cour et de cours actifs.",
    "welcome_screen_3": "Écran de bienvenue",
    "arrival_and_welcome_ambience": "Arrivée et ambiance de bienvenue",
    "hero_greeting_weather_highlights_and_next_tee_times_greet": "Héros salutations, faits saillants météo, et les prochains départs saluent les membres à l'entrée.",
    "split_view_2": "Vue divisée",
    "dual_feed_split_view": "Vue d ' un double flux",
    "competition_feed_runs_beside_sponsor_inventory_for_balanced_engagement": "Les flux de concurrence se déroulent à côté de l'inventaire des commanditaires pour un engagement équilibré.",
    "sponsor_advert_card_2": "Parrainage de la carte",
    "full_sponsor_card_feature": "Caractéristiques complètes de la carte de sponsor",
    "high_impact_sponsor_creative_sits_front_and_center_with": "La création de parrain à fort impact se situe avant et centre avec un cadrage haut de gamme.",
    "player_spotlight_mode": "Mode d ' éclairage du lecteur",
    "athlete_profile_treatment_with_live_ranking_and_next_up": "Traitement de profil d'athlète avec le classement en direct et les prochains appels.",
    "final_group_hole_16": "Groupe final · Trou 16",
    "court_1_semi_final": "Cour 1 semi-finale",
    "final_group_hole_12": "Groupe final · Hole 12",
    "court_2_quarter_final": "Finale du deuxième trimestre de la Cour",
    "final_group_hole_8": "Groupe final · Hole 8",
    "final_group_entering_signature_par_3_live_camera_window": "Final group enter signature par-3 live camera window.",
    "court_1_semi_final_entering_decisive_set_tie_break": "Cour 1 semi-finale entrant décisif coup d'égalité.",
    "hospitality_terrace_now_open_for_finals_spectators": "Terrasse d'accueil maintenant ouverte pour les spectateurs finals.",
    "on_fire": "En feu",
    "closing_hole": "Trou de fermeture",
    "bounce_back_momentum": "Accélération de l ' avance",
    "ethan_birdie_on_15": "Ethan birdie sur 15",
    "crowd_surge_at_center_court": "Foule surgissent à la cour du centre",
    "lucas_chip_in_replay": "Replay de Lucas",
    "semi_final_tie_break_begins": "Début de la rupture de cravate finale",
    "spotlight_switch_to_hole_16": "Interrupteur de projecteur au trou 16",
    "leaderboard_focus_4": "De haut niveau",
    "match_focus": "Focus sur le match",
    "finals_mode": "Mode final"
  }
};
